/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Audit_Logs_BlurbInputs */



/**
* | output |
* | --- |
* | "Audit logs record what happens in your organization, including user actions and AI interactions. Filter by user, action, or time, and export for reporting." |
*
* @param {Uno_Edu_Intro_Audit_Logs_BlurbInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_audit_logs_blurb = /** @type {((inputs?: Uno_Edu_Intro_Audit_Logs_BlurbInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Audit_Logs_BlurbInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Audit-Protokolle erfassen, was in Ihrer Organisation geschieht, einschließlich Benutzeraktionen und KI-Interaktionen. Filtern Sie nach Benutzer, Aktion oder Zeit und exportieren Sie für Berichte.")
	return /** @type {LocalizedString} */ ("Audit logs record what happens in your organization, including user actions and AI interactions. Filter by user, action, or time, and export for reporting.")
});